import {
  countingVuexGetters,
  CountingSchemes,
} from '@ahaslides-product/frontend-toolkit'
import config from '@/config'
import { isFeatureEnabled, isPresentationCreatedAfterTurnOnFlag, isPresentationResetAfterTurnOnFlag } from '../feature-toggles.module'

const isLiveProxyNotEnabledOnLocal = config.env === 'local' && !config.isLiveProxyUrlSet

const _getters = {
  ...countingVuexGetters,

  answerCountPerAnswerValue: (_, __, ___, rootGetters) => (
    activityId, questionId, version, answerValue,
  ) => {
    return rootGetters['counting/total'](CountingSchemes.answerCountPerAnswerValue({
      slideId: activityId,
      slideVersion: version,
      questionId,
      answerValue,
    })) ?? 0
  },
  canUseKvSyncLiveStats: (_, __, rootState, rootGetters) => {
    return (isPresentationCreatedAfterTurnOnFlag(rootGetters, 'kv-sync-emqx-for-live-stats') || isPresentationResetAfterTurnOnFlag(rootState.presentation, 'kv-sync-emqx-for-live-stats')) &&
      isFeatureEnabled(rootGetters, 'kv-sync-emqx-for-live-stats')
  },
  canSubmitReactionEmqx: (_, getters) => {
    return getters.canUseKvSyncLiveStats
  },
  canSubscribeReactionEmqx: (_, getters) => {
    return getters.canUseKvSyncLiveStats
  },
  canUseLiveStatsForQuizV2: (_, __, ___, rootGetters) => {
    if (isLiveProxyNotEnabledOnLocal) {
      return false
    }
    return isFeatureEnabled(rootGetters, 'livestats-quiz-submission-v2')
  },
  canUsePollLiveProxy: (_, getters, ___, rootGetters) => {
    if (!getters.canUseKvSyncLiveStats) return false
    if (isLiveProxyNotEnabledOnLocal) {
      return false
    }
    return isFeatureEnabled(rootGetters, 'liveproxy-submit-poll')
  },
  canUsePollLiveApi: (_, getters) => {
    return getters.canUseKvSyncLiveStats
  },
  canUseScaleLiveApi: (_, getters) => {
    return getters.canUseKvSyncLiveStats
  },
  canUseWordCloudLiveApi: (_, getters) => {
    return getters.canUseKvSyncLiveStats
  },
  canUseWordCloudLiveProxy: (_, getters, ___, rootGetters) => {
    if (!getters.canUseKvSyncLiveStats) return false
    if (isLiveProxyNotEnabledOnLocal) {
      return false
    }
    return isFeatureEnabled(rootGetters, 'liveproxy-submit-wordcloud')
  },
  canUseScaleLiveProxy: (_, getters, ___, rootGetters) => {
    if (!getters.canUseKvSyncLiveStats) return false
    if (isLiveProxyNotEnabledOnLocal) {
      return false
    }
    return isFeatureEnabled(rootGetters, 'liveproxy-submit-scale')
  },
  canUseReactionLiveProxy: (_, getters, ___, rootGetters) => {
    if (!getters.canUseKvSyncLiveStats) return false
    if (isLiveProxyNotEnabledOnLocal) {
      return false
    }
    return isFeatureEnabled(rootGetters, 'liveproxy-submit-reaction')
  },
}

export default _getters
